<template>
  <div class="content4 contentPage swiper-slide" :class="nowPage === 3 ? 'cartoon' : ''">
    <div class="animalNav" :style="{display: showNow === 0 ? 'flex' : 'none'}">
      <div class="leftTxtWrap">
        <img :src="txtImg" class="txtImg"/>
        <div class="heng"></div>
        <img :src="titleImg" class="titleImg"/>
        <div class="txtInfo">中生代是恐龙种类大爆发的时期，凶猛的大型兽脚类恐龙站在了食物链的顶端（如晚白垩世的暴龙），鸟臀类恐龙进一步分化出鸟脚类、剑龙、甲龙和角龙等亚目。海洋中的其他爬行动物也极为丰富，除了早期的鱼龙类和蛇颈龙类外，沧龙类也在晚白垩世广布于世界各地。翼龙类的发展亦更加完善，它们体型各异，种类繁多。身为恐龙后裔的鸟类和合弓纲的哺乳类成功适应了新环境，这两类温血动物也逐渐从幕后走到了台前。</div>
        <div class="btnWrap">
          <animalBtn 
            v-for="item in btnList" 
            :key="item.id" 
            :cnTitle='item.cnTitle' 
            :enTitle='item.enTitle'
            @click.native="changeShowAnimal(item.id)"
          ></animalBtn>
        </div>
      </div>
      <div class="rightImgWrap">
        <moveImg :imgSrc='rightAni' class="rightAni"></moveImg>
      </div>
    </div>
    <categoryAnimal 
      :animalType='reptilesAnimal.animalType' 
      :animalTypeEn='reptilesAnimal.animalTypeEn'
      :categoryTxt='reptilesAnimal.categoryTxt'
      :categoryInfoImg='reptilesAnimal.categoryInfoImg'
      :showList='reptilesAnimal.showList'
      @changeShowAnimal='changeShowAnimal'
      cssType='special'
      :show="showNow === 1"
    ></categoryAnimal>

    <categoryAnimal 
      :animalType='JeholBiotaAnimal.animalType' 
      :animalTypeEn='JeholBiotaAnimal.animalTypeEn'
      :categoryTxt='JeholBiotaAnimal.categoryTxt'
      :categoryInfoImg='JeholBiotaAnimal.categoryInfoImg'
      :showList='JeholBiotaAnimal.showList'
      @changeShowAnimal='changeShowAnimal'
      :show="showNow === 2"
    ></categoryAnimal>
  </div>
</template>

<script>
import { swiperMixin } from '@/utils/mixin.js'

import txtImg from '@/assets/img/content4/txtImg.png'
import titleImg from '@/assets/img/content4/titleImg.png'
import rightAni from '@/assets/img/content4/rightAni.png'

import { reptilesAnimal, JeholBiotaAnimal, btnList } from './data'

export default {
  mixins: [swiperMixin],
  data () {
    return {
      txtImg,
      titleImg,
      rightAni,
      reptilesAnimal,
      JeholBiotaAnimal,
      btnList, // 恐龙的种类
      showNow: 0, // 当前展示的是第几个
    }
  },

  computed: {
    nowPage () {
      return this.$store.state.nowPage
    }
  },

  watch: {
    nowPage ( nowPage ) {
      if ( nowPage === 3 && this.showNow > 0 ) {
        this.showNow = 0
      }
    }
  },

  // methods: {
  //   changeShowAnimal ( showNow ) {
  //     this.showNow = showNow
  //     this.$store.dispatch('setNextBtn', false)
  //   },
  // }
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/app.styl'
@import '../../stylus/animation.styl'
@import './content4.styl'
</style>